module.exports = __webpack_public_path__ + "assets/img/two-tab10-on.e07c34e7.png";